import { call, put, takeLatest } from 'redux-saga/effects';
import {
  getData,
  saveData,
  sendMail,
  confirmRequest,
} from '../../../services/setting/mailMagazineDetail.service';
import {
  ACTION_TYPE,
  actInitMailMagazineDetailSuccess,
  actCallUpdateMailMagazineDetailSuccess,
  actCallSendMailMagazineSuccess,
  actCallConfirmRequestSuccess,
} from './action';
import { actCallApiServerError } from '../../common/common/action';

/**
 * 初期表示
 *
 */
function* callApiInitMailMagazineDetail({ id }) {
  try {
    const data = yield call(getData, id);
    yield put(actInitMailMagazineDetailSuccess(data));
  } catch (error) {
    yield put(actCallApiServerError(error));
  }
}

/**
 * 保存
 *
 * @param
 */
function* callApiUpdateMailMagazineDetail({ data }) {
  try {
    const { id } = yield call(saveData, data);
    yield put(actCallUpdateMailMagazineDetailSuccess(id));
  } catch (error) {
    yield put(actCallApiServerError(error));
  }
}

/**
 * メール送信
 *
 * @param
 */
function* callApiSendMailMagazine({ id }) {
  try {
    yield call(sendMail, id);
    yield put(actCallSendMailMagazineSuccess());
  } catch (error) {
    yield put(actCallApiServerError(error));
  }
}

/**
 * 確認依頼
 *
 * @param
 */
function* actCallConfirmRequest({ id }) {
  try {
    yield call(confirmRequest, id);
    yield put(actCallConfirmRequestSuccess());
  } catch (error) {
    yield put(actCallApiServerError(error));
  }
}

/**
 * Export default root saga
 * @returns {IterableIterator<boolean>}
 */
export default function* watchCallMailMagazineDetail() {
  yield takeLatest(ACTION_TYPE.CALL_API_INIT_MAIL_MAGAZINE_DETAIL, callApiInitMailMagazineDetail);
  // eslint-disable-next-line max-len
  yield takeLatest(ACTION_TYPE.CALL_API_UPDATE_MAIL_MAGAZINE_DETAIL, callApiUpdateMailMagazineDetail);
  yield takeLatest(ACTION_TYPE.CALL_API_SEND_MAIL_MAGAZINE, callApiSendMailMagazine);
  yield takeLatest(ACTION_TYPE.CALL_API_CONFIRM_REQUEST, actCallConfirmRequest);
}
